module.exports = __webpack_public_path__ + "dafe34685e0d02a05f3580cd268c88db.svg";